import { Button } from '@purpur/library';
import Slider from 'react-slick';
import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const SliderWrapper = styled.div`
    position: relative;
`;

export const SliderFullScreen = styled(Slider)`
    width: 100%;
`;

export const ImageBoundary = styled.div`
    position: relative;
    height: calc(100vh - 350px);
    overflow: hidden;
    touch-action: none;
    margin-top: ${getPurpurSpacing('1000')};
    outline: none;
`;

type ImageWrapperProps = {
    $scale: number;
    $panOffset: { x: number; y: number };
};

export const ImageWrapper = styled.img<ImageWrapperProps>`
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 100%;
    max-height: calc(100vh - 350px);
    transform-origin: center center;
    transition: transform 0.1s ease-out;
    transform: ${({ $scale, $panOffset }) =>
        `translate(-50%, -50%) scale(${$scale}) translate(${$panOffset.x}px, ${$panOffset.y}px) `};
`;

export const ModalCloseButton = styled.button.attrs({ type: 'button' })`
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;

    background: transparent;
    border: 0;
    padding: 0;

    width: 3.75rem;
    height: 3.75rem;
    color: black;
    opacity: 1;
    text-shadow: none;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    margin: ${getPurpurSpacing('200')} 0;

    &:hover,
    &:focus {
        color: ${getPurpurColor('purple500')};
        opacity: 1;
    }
`;

export const BackToTheProduct = styled(Button)`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    margin: ${getPurpurSpacing('200')} 0 ${getPurpurSpacing('200')} ${getPurpurSpacing('100')};

    ${purpurMedia('md')`
        margin-left: ${getPurpurSpacing('300')};
    `};

    ${purpurMedia('lg')`
        margin-left: ${getPurpurSpacing('600')};
    `};
`;

type GalleryThumbnailProps = {
    $isActive: boolean;
};

export const GalleryLightBoxThumbnailsInRows = styled.div`
    position: fixed;
    bottom: ${getPurpurSpacing('200')};
    left: 50%;
    transform: translate(-50%);
    width: 100%;

    .slick-slide div {
        outline: revert !important;
    }

    & .slick-slide {
        display: grid;
        justify-content: center;
    }

    & .slick-slide > div:not(:last-of-type) {
        display: flex;
        justify-content: flex-start;
        gap: 0.5rem;
        margin-bottom: ${getPurpurSpacing('200')};

        ${purpurMedia('md')`
             gap: 1rem;
        `};
    }

    & .slick-slide > div:nth-last-of-type(2) {
        margin-bottom: 0;
    }

    & .slick-list {
        margin: 0 auto;
    }
`;

export const LightBoxAccessibilityDiv = styled.div`
    height: 3rem;
    line-height: 3rem;
    width: 3rem !important;

    ${purpurMedia('md')`
        height: 6.25rem;
        width: 6.25rem !important;
        line-height: 6.25rem;
    `};
`;

export const GalleryLightBoxThumbnail = styled.div<GalleryThumbnailProps>`
    cursor: pointer;
    float: left;
    font-size: 0;
    height: 3rem;
    line-height: 3rem;
    opacity: ${({ $isActive }) => ($isActive ? '1' : '0.25')};
    outline-offset: -1px;
    transition: opacity 0.15s ease-in-out;
    width: 3rem !important;

    &.active {
        opacity: 1;
    }

    ${purpurMedia('md')`
        height: 6.25rem;
        width: 6.25rem !important;
        line-height: 6.25rem;
    `};

    ${purpurMedia('lg')`
        &:hover {
            opacity: 1;
        }
    `};
`;

export const GalleryLightBoxThumbnailImg = styled.img`
    display: inline-block;
    margin: 0 auto;
    max-height: 100%;
    max-width: 100%;
`;
